/** Schieberegler statt Checkbox für Admin-Feature-Flags (grün=an/grau=aus). */
export function ToggleSwitch({ id, checked, onChange, label, darkMode, disabled }: {
  id: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: string;
  darkMode: boolean;
  disabled?: boolean;
}) {
  return (
    <label
      htmlFor={id}
      className={`inline-flex items-center gap-2 select-none ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
    >
      <span className="relative inline-block w-10 h-5 shrink-0">
        <input
          type="checkbox"
          id={id}
          checked={checked}
          disabled={disabled}
          onChange={ev => onChange(ev.target.checked)}
          className="sr-only"
        />
        <span
          className={`absolute inset-0 rounded-full transition-colors ${
            checked ? 'bg-green-500' : darkMode ? 'bg-slate-600' : 'bg-slate-300'
          }`}
        />
        <span
          className={`absolute top-0.5 left-0.5 w-4 h-4 bg-white rounded-full shadow transition-transform ${
            checked ? 'translate-x-5' : 'translate-x-0'
          }`}
        />
      </span>
      <span className={`text-sm ${darkMode ? 'text-slate-300' : 'text-slate-700'}`}>{label}</span>
    </label>
  );
}
